import { SemanticICONS } from 'semantic-ui-react';
import { UserPrivileges } from '../../session/constants';

export enum HitTypes {
    STRING = 'string',
    BOOLEAN = 'boolean',
    DOUBLE = 'double',
    DATE = 'date',
    MULTIPLE = 'multiple',
    FEATURE = 'feature',
    TABLE_ACTIONS = 'table_actions',
    DROPDOWN = 'dropdown',
}

export enum HitPrefix {
    COLUMN = 'search.hit.column.',
    PROP = 'search.hit.prop.',
}

export type SearchQuery = {
    readonly page: number;
    readonly hitsPerPage: number;
    readonly searchText: string;
    readonly filters: SearchFilters;
    readonly aggregations?: SearchAggregations;
    readonly columns: SearchColumn[];
    readonly source?: string;
    readonly searchTextFields?: string[];
};

export type SearchSortOrder = 'asc' | 'desc';
export type SearchColumnType = HitTypes.STRING | HitTypes.BOOLEAN | HitTypes.DOUBLE | HitTypes.DATE
| HitTypes.MULTIPLE | HitTypes.FEATURE | HitTypes.TABLE_ACTIONS | HitTypes.DROPDOWN;

export type SearchFilters = {
    [key: string]: any;
};

export type SearchAggregations = {
    [key: string]: any;
};

export interface NestedFilterObject {
    $path: string;
    [key: string]: any;
}

export type SearchColumn = {
    readonly fieldDefinitionId?: any;
    readonly name?: string;
    readonly type?: SearchColumnType;
    readonly order?: SearchSortOrder;
    readonly ref?: string;
    readonly width?: string;
    readonly nested?: string[];
    readonly sortField?: string;
    readonly valueBelongsToUser?: boolean;
    readonly icon?: SemanticICONS;
    readonly secondaryIcon?: SemanticICONS;
    readonly translate?: boolean;
    readonly filter?: any;
    readonly link?: boolean;
    readonly feature?: boolean;
    readonly sortDisabled?: boolean;
    readonly alt?: string;
    readonly useAlternativeValue?: string;
    readonly privilege?: UserPrivileges[];
    readonly internal?: boolean;
    readonly shouldProcessValue?: boolean;
    readonly seekAvailability?: boolean;
    readonly resourceId?: string;
    readonly resourceName?: string;
    readonly fieldType?: SearchColumnType;
    readonly noText?: boolean;
    readonly format?: string;
    readonly hideInColumnPicker?: boolean;
    readonly hidePopupInFixedLayout?: boolean;
    readonly sortEnabledOnWorkspace?: boolean;
    readonly expandable?: boolean;
    readonly isAPField?: boolean;
    readonly isMultipleAttemptsField?: boolean;
    readonly selectAllCheckbox?: boolean;
    readonly selectAllCheckboxTestId?: string;
    readonly selectAllCheckboxDisabled?: boolean;
    readonly selectAllCheckboxPopup?: string;
};

export type Section = {
    readonly section: string;
    readonly hits: HitData[];
};

export type SearchPredefinedFilters = {
    [key: string]: SearchFilters;
};

export type HitData = {
    [key: string]: any;
};

export interface DynamicFilterValues {
    [key: string]: any;
}

export interface Filter {
    name: string;
    default?: boolean;
    value?: any;
    lowerThan?: number;
    greaterThan?: number;
    tmp?: boolean;
    additionalNestedField?: string;
    additionalNestedValue?: any;
    onlyAppeals?: boolean;
}

export type BooleanQueryOperator = 'MUST' | 'SHOULD' | '';

export const DATE = 'date';
export const MULTIPLE = 'multiple';
export const NUMBER = 'number';

export enum Conditions {
    EQUALS = 'equals',
    LOWER_THAN = 'lowerThan',
    GREATER_THAN = 'greaterThan',
    BETWEEN = 'between',
}
